
import request from '@/utils/request'

//  获取会话 id
export function getCreateChat() {
  return request({
    url: '/coyote/ai/chat/create',
    method: 'get',
  })
}

// 上传图片
export function uploadFileImg(params) {
  return request({
    url: '/coyote/ai/upload',
    method: 'post',
    data: params,
  })
}

// 获取所有小区
export function querySystemInquiryDict(params) {
  return request({
    url: '/coyote/inquiryReport/querySystemInquiryDict',
    method: 'post',
    data: params,
  })
}

// 查询报告类型
export function queryReportTemplateDict() {
  return request({
    url: '/coyote/reportTemplate/queryReportTemplateDict',
    method: 'get',
  })
}

// 上传网络图片
export function uploadNetworkImages(params) {
  return request({
    url: '/coyote/supplementaryMaterials/upload/url',
    method: 'post',
    data: params,
  })
}


// 获取历史回话列表
export function getHistory() {
  return request({
    url: '/coyote/ai/conversations',
    method: 'get',
  })
}
// 根据历史对话id  查询历史对话信息
export function getHistoryMessage(params) {
  return request({
    url: '/coyote/ai/message',
    method: 'post',
    data: params,
  })
}